import React from 'react';

import {FormItemSkeleton, FormSectionSkeleton, SkeletonItem} from 'src/components/skeleton';

import {Group} from '@pb/kit-component-group';


export const LoginPageCustomizationSkeleton = () => (
    <FormSectionSkeleton labelWidth={402}>
        <Group direction="v" alignItems="start">
            <FormItemSkeleton labelWidth={144}>
                <SkeletonItem width={300} height={80}/>
            </FormItemSkeleton>
            <Group alignItems="center" gap="l">
                <FormItemSkeleton labelWidth={230}>
                    <SkeletonItem width={300} height={30}/>
                </FormItemSkeleton>
                <FormItemSkeleton labelWidth={230}>
                    <SkeletonItem width={300} height={30}/>
                </FormItemSkeleton>
            </Group>
            <FormItemSkeleton labelWidth={144}>
                <SkeletonItem width={300} height={80}/>
            </FormItemSkeleton>
        </Group>
    </FormSectionSkeleton>
);
